import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { authService } from '@/api'
import { useUserStore } from '@/state'
import { useStoreActions } from '@/store/store.hooks'
import { clearSsoSession } from '@/keycloak'

export const authKeys = {
  currentUser: ['auth', 'currentUser'],
}

export const useAccountActivation = () => {
  const setUser = useUserStore((state) => state.setUser)
  const queryClient = useQueryClient()
  const { setToken } = useStoreActions((actions) => actions.auth)

  return useMutation({
    mutationFn: authService.activateAccount,
    onSuccess: (data) => {
      // Legacy HS256 token: drop any stale 'sso' marker (see keycloak.js)
      clearSsoSession()

      // Set token in store FIRST (this triggers App re-render with authenticated state)
      setToken(data.token)

      // Also save to localStorage for persistence
      localStorage.setItem('token', data.token)

      // Update zustand store with user data
      setUser(data.user)

      // Update React Query cache
      queryClient.setQueryData(authKeys.currentUser, data.user)
    },
    onError: (error) => {
      console.error('Account activation failed:', error)
    },
  })
}

export const useGetActivationInfo = (token) => {
  return useQuery({
    queryKey: ['activation-info', token],
    queryFn: () => authService.getActivationInfo(token),
    enabled: !!token,
    retry: false,
  })
}
